import produce from 'immer';

import * as actionTypes from '../../actions/actionTypes';

const initialState = {
  byId: {}
};

/**
 * CONVERT TO USING REDUX TOOLKIT AS SOON AS POSSIBLE
 */
const reducer = produce((state, action) => {
  switch (action.type) {
    case actionTypes.divisions.SET_DIVISION:
      const existingDivision = state.byId[action.division.divisionId];
      let nextDivision;
      if (existingDivision !== undefined) {
        if (action.division.updatedAt > existingDivision.updatedAt) {
          nextDivision = {
            ...existingDivision,
            ...action.division
          };
        } else {
          // Nothing needs to be updated so just return the state.
          return;
        }
      } else {
        nextDivision = {
          ...action.division,
          properties: { byId: {} },
          users: { byId: {} }
        };
      }
      state.byId[nextDivision.divisionId] = nextDivision;
      return;
    case actionTypes.divisions.SET_DIVISIONS:
      if (Array.isArray(action.divisions)) {
        for (const division of action.divisions.reverse()) {
          const existingDivision = state.byId[division.divisionId];
          if (existingDivision !== undefined) {
            if (division.updatedAt > existingDivision.updatedAt) {
              state.byId[division.divisionId] = {
                ...existingDivision,
                ...division
              };
            }
          } else {
            state.byId[division.divisionId] = {
              ...division,
              properties: { byId: {} },
              users: { byId: {} }
            };
          }
        }
      }
      if (Array.isArray(action.divisionRelations)) {
        for (const divisionRelation of action.divisionRelations.reverse()) {
          const existingDivision = state.byId[divisionRelation.divisionId];
          // Make sure to a division object exists (even if an incomplete one must be created) so that the relation
          // objects have somewhere to go
          if (existingDivision === undefined) {
            state.byId[divisionRelation.divisionId] = {
              updatedAt: 0, // Ensures that any division updates with the same ID will overwrite this incomplete object
              properties: { byId: {} },
              users: { byId: {} }
            };
          }
          if (divisionRelation.variant === 'PROPERTY') {
            const existingRelation =
              state.byId[divisionRelation.divisionId].properties.byId[divisionRelation.relationalId];
            if (existingRelation === undefined || divisionRelation.updatedAt > existingRelation.updatedAt ) {
              state.byId[divisionRelation.divisionId].properties.byId[divisionRelation.relationalId] = divisionRelation;
            }
          } else {
            const existingRelation =
              state.byId[divisionRelation.divisionId].properties.byId[divisionRelation.relationalId];
            if (existingRelation === undefined || divisionRelation.updatedAt > existingRelation.updatedAt ) {
              state.byId[divisionRelation.divisionId].users.byId[divisionRelation.relationalId] = divisionRelation;
            }
          }
        }
      }
      return;
    default:
      return;
  }
}, initialState);

export default reducer;
